import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  release: window.SENTRY_RELEASE.id,
  integrations: [new Integrations.BrowserTracing()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.fd 
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
});